api = angular.module('api', ['bootstrap', 'ksc'])

api.run ['api/BootStrap', ->] # force bootstrap to load

module.exports = api
